import { TriptyqueStickers } from '@components/triptyque-stickers/models';
import { Block } from '@shared/models';

const getTriptyque = (id: 1 | 2 | 3): TriptyqueStickers => {
  switch (id) {
    case 1:
      return {
        title: 'Un concept qui a fait ses preuves',
        firstStickersColor: 'blue',
        stickerPairTexts: [
          ['8%', 'Rentabilité moyenne'],
          ['3 ans', 'Retour sur investissement'],
          ['2.5 M€', "CA moyen d'un franchisé"],
        ],
      };
    case 2:
      return {
        title: 'Votre futur magasin en chiffres',
        firstStickersColor: 'yellow',
        stickerPairTexts: [
          ['275 m²', 'Surface moyenne'],
          ['4', 'Nombre de collaborateurs moyen'],
        ],
      };
    case 3:
      return {
        title: 'Les chiffres pour investir',
        firstStickersColor: 'purple',
        hasGrayBackground: true,
        stickerPairTexts: [
          ['60 k€', 'Apport minimum'],
          ['300 k€', 'Retour sur investissement'],
          ['15 k€', "Chiffre d'affaire moyen"],
        ],
      };
  }
};

export const triptyqueStickersMock = (id: 1 | 2 | 3): Block<TriptyqueStickers> => ({
  type: 'triptyque-stickers',
  data: getTriptyque(id),
});
